import accounting from "accounting";
import countries from "./countries.json";
import municipalities from "./municipalities.json";
import languages from "./languages.json";
// application id for logger
export const APPLICATION_ID = 5;
//TODO: WILL CHANGE EVENT TYPE TEXT LATER
export const LOCALIZATION_FILE_URL =
  "http://localhost:4001/api/graph-csv-to-json";
//FormServer Base URL to be used for static files
export let formserverBaseURL = "";

// activity validations tronsformation to yup libarary validation
// main validations like yup.number() for number data type
const transformToYupValidaitonTypes = {
  money: "string",
  file: "mixed",
  date: "date",
  datetime: "date",
  integer: "number",
  float: "number",
  int: "number",
  slider: "number",
  email: "string",
};

// activity validations tronsformation to yup libarary validation
// sub validations like yup.string().max(6) max is the sub validation of string type
const transformToSubValidaitonTypes = {
  required: "required",
  minLength: "min",
  maxLength: "max",
  minValue: "min",
  maxValue: "max",
  IsNumeric: "matches",
  maxZeros: "matches",
  danishCPR: "matches",
  danishCVR: "matches",
  extension: "test",
  fileSize: "test",
  float: "typeError",
  int: "typeError",
  integer: "typeError",
  email: "email",
};

// regex for spacific type of activities
const activityRegex = {
  IsNumeric: /^\d+$/,
  maxZeros: /^(?!0+$)[a-zA-Z0-9]+$/,
  danishCPR: /[0-3][0-9][0-1][1-9]\d{2}-\d{4}?[^0-9]*/,
  danishCVR: /^\d{8}$/,
};

export const HTML_ESCAPE_TYPES = {
  text: "text",
  textbox: "textbox",
  longtext: "longtext",
  password: "password",
  richtext: "richtext",
  choice: "choice",
  html: "html"
};

const APP_LOCALE = {
  da: "da",
  "da-DK": "da",
  pt: "pt",
  "pt-BR": "pt-BR",
  es: "es",
  "es-AR": "es-AR",
  en: "en-US",
  "en-US": "en-US",
  ca: "ca",
  de: "de",
  "de-DE": "de",
  it: "it",
  "it-IT": "it",
  sv: "sv",
  "sv-SE": "sv",
  nb: "nb",
  "nb-NO": "nb",
  "en-GB": "en-GB",
  gb: "en-GB",
  fi: "fi",
  ru: "ru",
  lv: "lv",
  lt: "lt",
};

export const getBrowserLocale = (language) => APP_LOCALE[language] || language;

export const isSubProcess = (type) => type === "singleInstanceSubProcess";

const getValidationType = (element) => {
  const { presentationType } = element;
  return transformToYupValidaitonTypes[presentationType] || "string";
};

export const getValidations = (element, selectedEvent, defaultMsgs) => {
  let validations = [];
  const DEFAULT_MSG_TYPES = {
    float: "double",
    integer: "integer",
    int: "int",
    email: "email",
  };

  const TYPE_TO_TOKENS = {
    float: "number",
    integer: "digits",
    int: "digits",
    email: "email",
  };

  if (DEFAULT_MSG_TYPES[element.presentationType]) {
    validations = [
      {
        type: transformToSubValidaitonTypes[element.presentationType],
        params: [
          setLocalization(
            defaultMsgs[TYPE_TO_TOKENS[element.presentationType]]
          ),
        ],
      },
    ];
  }
  if (selectedEvent && selectedEvent.pending) {
    validations = [
      ...validations,
      {
        type: transformToSubValidaitonTypes["required"],
        params: [setLocalization(defaultMsgs["required"])],
      },
    ];
  }

  validations = [
    ...validations,
    ...element.validationRules.map((validation) => {
      const { parameters, customMessage } = validation.rule;
      let params = [customMessage];
      const id = validation.rule["@id"];
      if (parameters && parameters.parameter["@value"]) {
        params = [parameters.parameter["@value"], customMessage];
      }

      if (id && !parameters) {
        params = [activityRegex[id], customMessage];
      }

      return {
        type: transformToSubValidaitonTypes[id],
        ruleType: id,
        params,
      };
    }),
  ];

  return {
    validations,
    validationType: getValidationType(element),
  };
};

export const getChoices = ({ choices }, events) => {
  if (choices === null) return { entries: [] };
  if (choices.dataSetList) {
    const selectedLanguage = "en-US";
    const list = {
      countries: countries.data[selectedLanguage],
      municipalities: municipalities.data,
      languages: languages.data,
    };
    return { ...choices, entries: list[choices.dataSetList] || [] };
  } else if (choices.dataSetActivity) { 
    const dataSetEvent = events.find((item) => item.id === choices.dataSetActivity);
    if (dataSetEvent?.value) {
      const feelListJson = isKeyValuePairJson(dataSetEvent.value);
      if (feelListJson) {
        const entries = feelListJson.map(op => ({value: op[0], label: op[1]}));
        return { ...choices, entries: entries || [] };
      }
    }
    return { ...choices, entries: [] };
  }
  return choices;
};

function isKeyValuePairJson(jsonStr) {
  try {
    const json = JSON.parse(jsonStr.replace(/'/ig, '"')); //[[1,'a'],[2,'b'],[3,'c']], Replacing singlequote(') with doublequote(") to make it a valid json string
    if (
      Array.isArray(json) &&
      json.length > 0 &&
      json.every(op => op.length === 2)
    ) {
      return json;
    }
    return false;
  } catch (e) {
    return false;
  }
}

const transformToErrorType = (activity) => {
  return activity.presentationType === "label" && activity.pending
    ? "error"
    : activity.presentationType;
};

const localeDefs = {
  da: "da-DK",
  "da-DK": "da-DK",
  en: "en-US",
  "en-US": "en-US",
  pt: "pt-BR",
  "pt-BR": "pt-BR",
  es: "es",
  "es-AR": "es",
  ca: "ca",
};

const setLocalization = (item, language) => {
  if (!item) {
    item = {};
  }
  if (!language) {
    language = navigator.language;
  }
  return item[localeDefs[language]] || item["en-US"];
};

const getIncludedActivities = (elements) => {
  return elements.filter(
    ({ type, presentationType, dataType }) =>
      (dataType && presentationType) || isSubProcess(type)
  );
};

export const getFormatedValue = (presentationType, value) => {
  if (presentationType === "money") {
    return formatMoney(value);
  }
  if (presentationType === "float") {
    return formatFloat(value, navigator.language);
  }
  if (HTML_ESCAPE_TYPES[presentationType]) {
    return htmlEscapeDecode(value);
  }
  return value !== null ? value : "";
};

const getSelectedActivity = ({ events, element, defaultMsgs }) => {
  const selectedEvent = events && events.length > 0 && events.find((item) => item.id === element.activityId);

  const value =
    selectedEvent && selectedEvent.value !== null ? selectedEvent.value : "";
  if (isSubProcess(element.type)) {
    element.elements.forEach((item) =>
      getSelectedActivity({ events, element: item, defaultMsgs })
    );
  }

  Object.assign(element, selectedEvent);
  element.previousValue = value;
  element.value = getFormatedValue(element.presentationType, value);
  element.executedValue = value;
  element.choices = getChoices(element, events);
  Object.assign(element, getValidations(element, selectedEvent, defaultMsgs));
  return element;
};

const getGraphLocalization = (activity, graphLocalizedJSON) => {
  const filteredEvent = graphLocalizedJSON.Events.find(
    (event) => event.id === activity.id
  );

  const formActivity = {
    ...activity,
    presentationType: transformToErrorType(activity),
    hinttext:
      filteredEvent && filteredEvent.hinttext
        ? setLocalization(filteredEvent.hinttext)
        : activity.hinttext,
    label:
      filteredEvent && filteredEvent.label
        ? setLocalization(filteredEvent.label)
        : activity.label,
    placeholder:
      filteredEvent && filteredEvent.placeholder
        ? setLocalization(filteredEvent.placeholder)
        : activity.placeholder,
  };

  return formActivity;
};

export const mergeFieldsIntoForm = ({
  form,
  events,
  accepting,
  phaseNo,
  graphLocalizedJSON,
}) => {
  const phases = form.phases.map((phase) => {
    const elements = getIncludedActivities(phase.elements).map((element) => {
      const selectedActivity = getSelectedActivity({
        events,
        element,
        defaultMsgs: graphLocalizedJSON.DefaultMsgs,
      });

      return getGraphLocalization(selectedActivity, graphLocalizedJSON);
    });
    return { ...phase, elements: elements };
  });

  const formBtns = getLocalizedBtns(
    graphLocalizedJSON,
    form.sendtext ? form.sendtext : "Close",
    form.canceltext ? form.canceltext : "Cancel"
  );

  return {
    ...form,
    accepting,
    phaseNo,
    phases,
    ...formBtns,
  };
};

const getLocalizedBtns = (graphLocalizedJSON, sendText, cancelText) => {
  return {
    sendtext:
      graphLocalizedJSON.FormButtons && graphLocalizedJSON.FormButtons.sendText
        ? setLocalization(graphLocalizedJSON.FormButtons.sendText)
        : sendText,
    canceltext:
      graphLocalizedJSON.FormButtons &&
      graphLocalizedJSON.FormButtons.cancelText
        ? setLocalization(graphLocalizedJSON.FormButtons.cancelText)
        : cancelText,
  };
};
export const getFilePath = (uploadServiceUrl, DCRtoken, filename) => {
  return `${uploadServiceUrl}/upload/${DCRtoken}/${filename}`;
};

export const setFormserverBaseURL = (url) => {
  formserverBaseURL = `${url}/`;
};

export const downloadRemoteFile = (remoteUrl, filename) => {
  if (!filename) {
    filename = remoteUrl.split('/').pop();
  }
  fetch(remoteUrl)
  .then(res => res.blob())
  .then(blob => {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  })
};

export const isHttpUrl = (str) => {
  let url;
  try {
    url = new URL(str);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}

export const isJavaScriptFunction = (str) => {
  return window[str] && typeof window[str] === 'function';
};

export const isGuid = (str) => {
  return /^[0-9A-Fa-f\\-]+$/.test(str);
};

export const setTabTitle = (title) => {
  // check if title is not null and the url is of SOP e.g. /sop/{GUID}/
  if (title && /^(\/sop\/).+$/.test(window?.location?.pathname)) {
    document.title = title;
  }
};

export const isRequiredWithValue = ({
  pending,
  executedValue,
  validations,
}) => {
  return (
    pending &&
    executedValue &&
    validations.filter(({ type }) => type === "required").length > 0
  );
};

export const DEFAULT_MSGS = {
  required: {
    eventType: "DEFAULT_MSG",
    id: 1,
    type: "defaultMsg",
    token: "required",
    "en-US": "This field is required.",
    "da-DK": "Dette felt er påkrævet.",
    es: "Ce champ est requis.",
    ca: "Aquest camp és obligatori.",
  },
  number: {
    eventType: "DEFAULT_MSG",
    id: 2,
    type: "defaultMsg",
    token: "number",
    "en-US": "Please enter a valid number.",
    "da-DK": "Indtast venligst et gyldigt nummer.",
    es: "as-S'il vous plait, entrez un nombre valide.",
    ca: "Introduïu un número vàlid.",
  },
  email: {
    eventType: "DEFAULT_MSG",
    id: 3,
    type: "defaultMsg",
    token: "email",
    "en-US": "Please enter a valid email address.",
    "da-DK": "Indtast venligst en gyldig e-mailadresse.",
    es: "Por favor, introduce una dirección de correo electrónico válida.",
    ca: "Siusplau, introdueixi una adreça de correu electrònic vàlida.",
  },
  url: {
    eventType: "DEFAULT_MSG",
    id: 4,
    type: "defaultMsg",
    token: "url",
    "en-US": "Please enter a valid URL.",
    "da-DK": "Indtast venligst en gyldig URL.",
    es: "Por favor introduzca un URL válido.",
    ca: "Introduïu un URL vàlid.",
  },
  digits: {
    eventType: "DEFAULT_MSG",
    id: 5,
    type: "defaultMsg",
    token: "digits",
    "en-US": "Please enter only digits.",
    "da-DK": "Indtast kun cifre.",
    es: "Por favor ingrese solo dígitos.",
    ca: "Introduïu només dígits.",
  },
};

const moneyFormatOptions = (lang = "en-US") => {
  const customOptions = {
    default: {
      thousand: ",",
      decimal: ".",
      unformat: ".",
    },
    european: {
      thousand: ".",
      decimal: ",",
      unformat: ",",
    },
    finnish: {
      thousand: " ",
      decimal: ",",
      unformat: ",",
    },
  };

  const config = {
    "en-US": "default",
    da: "european",
    "da-DK": "european",
    sv: "european",
    pt: "european",
    "pt-BR": "european",
    es: "european",
    "es-AR": "european",
    "de-DE": "european",
    "it-IT": "european",
    "sv-SE": "european",
  };

  return {
    symbol: "",
    precision: 2,
    format: {
      neg: "%s (%v)",
      zero: "%s",
      pos: "%s %v",
    },
    ...customOptions[config[lang]],
  };
};

export const formatMoney = (value) => {
  const unformatedValue = unformatMoney(value);
  if (unformatedValue === 0) return "";
  const formatted = accounting.formatMoney(
    unformatedValue,
    moneyFormatOptions(navigator.language)
  );
  return formatted.toString().trim();
};

export const unformatMoney = (value) => {
  const unformatedValue = accounting.unformat(
    value,
    moneyFormatOptions(navigator.language).unformat
  );
  if (unformatedValue === 0) return "";
  return accounting.unformat(
    value,
    moneyFormatOptions(navigator.language).unformat
  );
};

export const formatFloat = (value = "", locale) => {
  if (!value) return "";
  value = new Intl.NumberFormat(locale).format(value);
  return value.replace(/\s/g, " ");
};

//REF: https://stackoverflow.com/questions/48950796/how-to-revert-tolocalestring
export const unformatFloat = (value = "", locale) => {
  if (!isNaN(value)) return value;
  const parts = (1234.5).toLocaleString(locale).match(/(\D+)/g);
  let unformatted = value.replace(/\s/g, "");
  unformatted = unformatted.split(parts[0]).join("");
  unformatted = unformatted.split(parts[1]).join(".");
  return parseFloat(unformatted);
};

export const htmlEscape = (str) => {
  return String(str)
    .replace(/\n/g, "&#xA;")
    .replace(/\\/g, "&bsol;");
};

export const htmlEscapeDecode = (str) => {
  if (str === null || str === undefined) return str;
  return String(str)
    .replace(/&amp;/g, "&")
    .replace(/&#xA;/g, "\n")
    .replace(/&sol;/g, "/")
    .replace(/&bsol;/g, "\\")
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
};

export const replaceSlashes = (str) => {
  return (str + "").replace(/\\/g, "\\\\");
};

export const removeSlashes = (str) => {
  return (str + "").replace(/\\/g, "");
};

export const isCSVString = (csv) => {
  //check if given string is valid CSV file
  return /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/.test(
    csv
  );
};

export const isFocused = (elem) => {
  return document.activeElement === elem;
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text ?? "");
};

export const copySubprocessToClipboard = (element) =>{
  if (element?.elements?.length > 0) {
    const fieldsContent = element.elements.map(e => e.value).join('\n').trim();
    navigator.clipboard.writeText(fieldsContent ?? "");
  }
};

export const isValidJSON = (value) => {
  try {
    JSON.stringify(value);
    return true;
  } catch (_) {
    return false;
  }
};

export const isValidJSONString = (value) => {
  try {
    JSON.parse(value);
    return true;
  } catch (_) {
    return false;
  }
};